import { Security } from '@okta/okta-react';
import { RestoreOriginalUriFunction } from '@okta/okta-react/bundles/types/OktaContext';
import { Suspense } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { Loading } from './components/progress';
import { ErrorHandlerContextHandler } from './contexts';
import { SocketIoProvider } from './contexts/SocketIoProvider';
import oktaAuthClient, { getRelativeUrl } from './utils/oktaAuth';

function App() {
  const navigate = useNavigate();
  const restoreOriginalUri: RestoreOriginalUriFunction = (
    _oktaAuth,
    originalUri
  ) => {
    return navigate(getRelativeUrl(originalUri || '/'));
  };
  return (
    <Suspense fallback={<Loading />}>
      <Security
        oktaAuth={oktaAuthClient}
        restoreOriginalUri={restoreOriginalUri}
      >
        <ErrorHandlerContextHandler>
          <SocketIoProvider>
            {/* <WebSocketProvider> */}
            <Outlet />
            {/* </WebSocketProvider> */}
          </SocketIoProvider>
        </ErrorHandlerContextHandler>
      </Security>
    </Suspense>
  );
}

export default App;
